// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"561":"99e27993","653":"c3aad1bc","976":"098cd66f"}[chunkId] + ".css";
};